import { gql } from '@apollo/client';

export const FrontPageHero = gql`
  fragment FrontPageHero on PageBodyFrontpage_hero {
    type
    primary {
      alignment
      title
      text_center
      text_bottom
      shade_opacity
      image
      button_text
      title_width
      title_position
      title_color
      font_size
      link {
        ...LinkFragment
      }
    }
  }
`;

export const SubPageHero = gql`
  fragment SubPageHero on PageBodyHero {
    type
    primary {
      background_color
      title
      smaller_font
      copy
      image
      image_overflow
      hero_video: video {
        ...LinkFragment
      }
      button_text
      special_hero
      link {
        ...LinkFragment
      }
      button_text_2
      link_2 {
        ...LinkFragment
      }
    }
  }
`;

export const CompactHero = gql`
  fragment CompactHero on PageBodyCompact_hero {
    type
    primary {
      title
      copy
    }
  }
`;

export const SliceJotForm = gql`
  fragment SliceJotForm on PageBodyJotform {
    type
    primary {
      url
    }
  }
`;

export const SliceText = gql`
  fragment SliceText on PageBodyText {
    type
    primary {
      text
      indent
    }
  }
`;

export const SliceTextWithPoints = gql`
  fragment SliceTextWithPoints on PageBodyText_with_points {
    type
    primary {
      title
      title_size
      copy
      copy_size
      link {
        ...LinkFragment
      }
      link_text
      points_type
      points_color
      line_splitter
      columns_count
      points_location
      point_copy_size
    }
    fields {
      copy: item
      icon
      label
      point_link {
        ...LinkFragment
      }
    }
  }
`;

export const SliceIntroText = gql`
  fragment SliceIntroText on PageBodyIntro_text {
    type
    primary {
      title
      copy
      copy_size
      link {
        ...LinkFragment
      }
      link_text
    }
  }
`;

export const SliceImages = gql`
  fragment SliceImages on PageBodyImages {
    type
    primary {
      title
      copy
      aspect_ratio
      featured
      issvg
      columns
    }
    fields {
      image_title
      image_copy
      image
      video
    }
  }
`;

export const SliceEmbed = gql`
  fragment SliceEmbed on PageBodyEmbed {
    type
    primary {
      embed
      embed2
      height
    }
  }
`;

export const SliceTableWithImages = gql`
  fragment SliceTableWithImages on PageBodyTable_with_images {
    type
    primary {
      footer_text
      has_header
    }
    fields {
      image
      text_1
      text_2
      text_3
      text_4
      text_5
      isheader
    }
  }
`;

export const SliceRelatedContent = gql`
  fragment SliceRelatedContent on PageBodyRelated_content {
    type
    fields {
      title
      copy
      link {
        ...LinkFragment
        ... on Page {
          _meta {
            id
            uid
            tags
            lang
          }
          body {
            __typename
            ... on PageBodyHero {
              type
              primary {
                title
              }
            }
          }
        }
      }
      icon
    }
  }
`;
export const SliceProductCards = gql`
  fragment SliceProductCards on PageBodyProduct_cards {
    type
    primary {
      featured
      align
      four_in_row
    }
    fields {
      image
      heading
      copy
      video
      text_in_image
      link {
        ...LinkFragment
      }
    }
  }
`;
export const SliceArticleCards = gql`
  fragment SliceArticleCards on PageBodyArticle_cards {
    type
    primary {
      align
      title
      link {
        ...LinkFragment
      }
    }
    fields {
      image
      heading
      copy
      link {
        ...LinkFragment
      }
    }
  }
`;
export const SliceOtherCards = gql`
  fragment SliceOtherCards on PageBodyOther_cards {
    type
    primary {
      featured
    }
    fields {
      image
      title
      copy
      link {
        ...LinkFragment
      }
      link_text
    }
  }
`;

export const SliceTextCards = gql`
  fragment SliceTextCards on PageBodyText_cards {
    type
    fields {
      title
      copy
      link {
        ...LinkFragment
      }
      link_text
    }
  }
`;

export const SliceDownloadLinks = gql`
  fragment SliceDownloadLinks on PageBodyDownload_links {
    type
    primary {
      app_store {
        ...LinkFragment
      }
      google_play {
        ...LinkFragment
      }
      apple_link_text
      google_link_text
    }
  }
`;

export const HighlightNumbers = gql`
  fragment HighlightNumbers on PageBodyHighlight_numbers {
    type
    primary {
      size
      color
    }
    fields {
      title
      copy
      prefix
      number
      suffix
    }
  }
`;

export const SlicePageVideo = gql`
  fragment SlicePageVideo on PageBodyVideo_el {
    type
    primary {
      body_video: video {
        ...LinkFragment
      }
    }
  }
`;

export const SliceArticleHero = gql`
  fragment SliceArticleHero on PageBodyArticle_hero {
    type
    primary {
      a_link {
        ...LinkFragment
      }
      a_link_text
      a_title
      a_image
      a_abstract
    }
  }
`;

export const SliceFeaturedArticles = gql`
  fragment SliceFeaturedArticles on PageBodyFeatured_articles {
    type
    fields {
      a_article {
        ...LinkFragment
      }
      a_image
      a_title
      a_abstract
    }
  }
`;

export const SliceTextWithImage = gql`
  fragment ArticleSliceTextWithImage on PageBodyText_with_image {
    type
    primary {
      copy
      image
      align
    }
  }
`;

export const SliceTextWithVideo = gql`
  fragment ArticleSliceTextWithVideo on PageBodyText_with_video {
    type
    primary {
      copy
      video
      align
    }
  }
`;

export const SliceTextWithPullOut = gql`
  fragment ArticleSliceTextWithPullOut on PageBodyText_with_pull_out {
    type
    primary {
      copy
      pullout
    }
  }
`;

export const SliceTextWithWithSideText = gql`
  fragment ArticleSliceTextWithSideText on PageBodyText_with_side_text {
    type
    primary {
      copy
      side_text
      side_title
    }
  }
`;

export const SliceTextWithRelated = gql`
  fragment ArticleSliceTextWithRelated on PageBodyText_with_related {
    type
    primary {
      copy
    }
    fields {
      image
      title
      copy
      link_text
      link {
        ...LinkFragment
      }
    }
  }
`;

export const SliceTextWithLinks = gql`
  fragment ArticleSliceTextWithLinks on PageBodyText_with_links {
    type
    primary {
      title
      copy
    }
    fields {
      link_text
      link {
        ...LinkFragment
      }
    }
  }
`;

export const SliceQuote = gql`
  fragment ArticleSliceQuote on PageBodyQuote {
    type
    primary {
      quote
      author
      position
      align
    }
  }
`;

export const SliceVideo = gql`
  fragment ArticleSliceVideo on PageBodyVideo {
    type
    primary {
      title1
      copy
      video
    }
  }
`;

export const SliceEmphasisText = gql`
  fragment ArticleSliceEmphasisText on PageBodyEmphasis_text {
    type
    primary {
      copy
    }
  }
`;

export const AnnualHero = gql`
  fragment AnnualHero on PageBodyAnnual_report_hero {
    type
    primary {
      title
      image
      shade_opacity
    }
  }
`;

export const SliceAnnualModule = gql`
  fragment AnnualModule on PageBodyAnnual_module {
    type
    primary {
      copy
      action_link {
        ...LinkFragment
      }
      action_title
      charts
      layout_type
    }
    fields {
      a_title
      value
      percentage
    }
  }
`;

export const Tiles = gql`
  fragment Tiles on PageBodyTiles {
    type
    fields {
      number
      title
      copy
      icon
      link {
        ...LinkFragment
      }
    }
  }
`;

export const AnnualIntro = gql`
  fragment AnnualIntro on PageBodyAnnual_intro {
    type
    primary {
      title
      copy
      splitter
    }
  }
`;

export const AnnualQuote = gql`
  fragment AnnualQuote on PageBodyAnnual_quote {
    type
    primary {
      align
    }
    fields {
      image
      copy
      link {
        ...LinkFragment
      }
      link_text
    }
  }
`;

export const SliceBecomeCustomer = gql`
  fragment SliceBecomeCustomer on PageBodyBecome_a_customer {
    type
    primary {
      title
      copy
      background
      link_text
      link {
        ...LinkFragment
      }
    }
  }
`;

export const TextWithNumbers = gql`
  fragment TextWithNumbers on PageBodyText_with_numbers {
    type
    primary {
      copy
      label
      description
      color
    }
    fields {
      number
      text
      link {
        ...LinkFragment
      }
    }
  }
`;

export const Boxes = gql`
  fragment Boxes on PageBodyBoxes {
    type
    fields {
      image
      copy
      table
      align_content
    }
  }
`;

export const TableWithLargeText = gql`
  fragment TableWithLargeText on PageBodyTable_with_large_text {
    type
    primary {
      text
    }
    fields {
      text_1
      text_2
      text_3
      text_4
      text_5
      isheader
      isfooter
      bold
    }
  }
`;

export const SliceServiceLocations = gql`
  fragment SliceServiceLocations on PageBodyService_locations {
    type
  }
`;

export const SlicePoints = gql`
  fragment SlicePoints on PageBodyPoints {
    type
    fields {
      title
      text
    }
    primary {
      title
      text
      featured_point_title
      featured_point_text
      isgray
    }
  }
`;

export const SliceFaq = gql`
  fragment SliceFaq on PageBodyFaq {
    type
    primary {
      heading
      single_display
    }
    fields {
      item {
        ... on Faq_item {
          question
          answer
        }
      }
      category {
        ... on Faq_category {
          title
        }
      }
    }
  }
`;

export const SliceContentNav = gql`
  fragment SliceContentNav on PageBodyContent_nav {
    type
    primary {
      heading
    }
    fields {
      subheading
      copy
    }
  }
`;

export const SliceInterestCallout = gql`
  fragment SliceInterestCallout on PageBodyInterest_callout {
    type
    label
    fields {
      title
      copy
      sub_title
      number
      number_color
      subtitle_position
      link {
        ...LinkFragment
      }
    }
  }
`;

export const SliceStaffWithContact = gql`
  fragment SliceStaffWithContact on PageBodyStaff_with_contact {
    type
    primary {
      title
      three_per_line
    }
    fields {
      employee {
        ... on Employee {
          image
          name
          title
          email
          phone
          location
        }
      }
    }
  }
`;

export const SliceStaffWithBio = gql`
  fragment SliceStaffWithBio on PageBodyStaff_with_bio {
    type
    primary {
      title
    }
    fields {
      employee {
        ... on Employee {
          image
          name
          title
          bio
        }
      }
    }
  }
`;

export const SliceDetailCards = gql`
  fragment SliceDetailCards on PageBodyDetail_cards {
    type
    primary {
      title
      three_per_line
    }
    fields {
      image
      detail_title
      details
      show_image
    }
  }
`;

export const SliceNewsCards = gql`
  fragment SliceNewsCards on PageBodyNews_cards {
    type
    primary {
      heading
      heading_link {
        ...LinkFragment
      }
      featured
      articles
    }
    fields {
      article {
        ...LinkFragment
      }
      category {
        ... on Article_category {
          _meta {
            id
            uid
          }
          title
        }
      }
      article_abstract
    }
  }
`;

export const SliceMoreInfo = gql`
  fragment SliceMoreInfo on PageBodyMore_info {
    type
    primary {
      title
      expandable
    }
    fields {
      image
      title
      copy
      expandable
    }
  }
`;

export const SliceCardInfo = gql`
  fragment SliceCardInfo on PageBodyCard_info {
    type
    primary {
      title
      copy
      image
      insurance
      terms {
        ...LinkFragment
      }
    }
    fields {
      first_text
      second_text
    }
  }
`;

export const SliceCustomModule = gql`
  fragment SliceCustomModule on PageBodyCustom_module {
    type
    primary {
      module
      background
    }
  }
`;

export const SliceHousingLoanCalculator = gql`
  fragment SliceHousingLoanCalculator on PageBodyHousing_loan_calculator {
    type
    primary {
      refinancing
    }
  }
`;

export const SliceIframe = gql`
  fragment SliceIframe on PageBodyIframe {
    type
    primary {
      copy
    }
  }
`;

export const SliceMailingList = gql`
  fragment SliceMailingList on PageBodyMailing_list {
    type
    primary {
      mailing_list_categories
    }
    fields {
      mailing_list_category
      mailing_list_title
      mailing_list_text
      mailing_list_order
    }
  }
`;

export const SliceTable = gql`
  fragment SliceTable on PageBodyTable {
    type
    primary {
      bg: background
      layout
      zebra_color
      text
      table_title
      table
    }
  }
`;

export const SliceQuarters = gql`
  fragment SliceQuarters on PageBodyQuarters {
    type
    fields {
      copy
      link {
        ...LinkFragment
      }
    }
  }
`;

export const SliceTextWithImages = gql`
  fragment SliceTextWithImages on PageBodyText_with_images {
    type
    primary {
      title
      copy
      align
      link_text
      aspect_ratio
      link {
        ...LinkFragment
      }
      link_2_text
      link_2 {
        ...LinkFragment
      }
    }
    fields {
      image
      video
      embed
      infogramid
    }
  }
`;

export const SliceAccordion = gql`
  fragment SliceAccordion on PageBodyAccordion {
    type
    primary {
      is_open
      single_display
    }
    fields {
      page {
        ... on Page {
          _meta {
            id
            uid
            tags
            lang
          }
          page_title
          body {
            ...SliceQuarters
            ...SliceTextWithImages
            ...SliceTable
          }
        }
      }
    }
  }
`;

export const SliceMarkets = gql`
  fragment SliceMarkets on PageBodyMarkets {
    type
    primary {
      instrument
      order
      disclaimer
    }
  }
`;

export const SliceEventRegistration = gql`
  fragment SliceEventRegistration on PageBodyEvent_sign_up {
    type
    label
    primary {
      event_id
      image
      description
      use_phonenumber
      use_kennitala
      use_company_name
      use_company_kennitala
      max_number_registering
      max_number_registering_label
      title
    }
    fields {
      field_name
      field_type
      field_position
      field_size
    }
  }
`;

export const SliceGdprRequest = gql`
  fragment SliceGdprRequest on PageBodyGdprrequest {
    type
    primary {
      type
      text
      header
      login_title
      login_description
      login_image
    }
  }
`;

export const SliceShortcuts = gql`
  fragment SliceShortcuts on PageBodyShortcuts {
    type
    fields {
      icon
      link {
        ...LinkFragment
      }
      link_text
    }
  }
`;

export const SliceFeaturedPodcasts = gql`
  fragment SliceFeaturedPodcasts on PageBodyFeatured_podcasts {
    type
    primary {
      title
      description
      button_text
      button_link {
        ...LinkFragment
      }
    }
    fields {
      podcast_link {
        ...LinkFragment
      }
      podcast_duration
    }
  }
`;

export const SliceOrderGiftCard = gql`
  fragment SliceOrderGiftCard on PageBodyOrder_gift_card {
    type
    primary {
      type
    }
  }
`;

export const SliceBookAppointment = gql`
  fragment SliceBookAppointment on PageBodyBook_appointment {
    type
    primary {
      type
      default_corporate_service
      default_personal_service
      image
      copy
      title
    }
  }
`;

export const SliceTermsDialog = gql`
  fragment SliceTermsDialog on PageBodyTerms_dialog {
    type
    primary {
      title
      content
      open_on_load
    }
  }
`;

export const SliceKauphollNews = gql`
  fragment SliceKauphollNews on PageBodyKaupholl_news {
    type
    primary {
      title
      description
      count
    }
  }
`;

export const SliceImageLink = gql`
  fragment SliceImageLink on PageBodyImage_link {
    type
    fields {
      title
      link {
        ...LinkFragment
      }
      color
      image
    }
  }
`;

export const SliceInfogram = gql`
  fragment SliceInfogram on PageBodyInfogram {
    type
    primary {
      infogramid
    }
  }
`;

export const SliceScrollToModuleOnLoad = gql`
  fragment SliceScrollToModuleOnLoad on PageBodyScrolltomoduleonload {
    type
    fields {
      module_name
    }
  }
`;

export const allFragments = [
  FrontPageHero,
  SubPageHero,
  CompactHero,
  SliceText,
  SliceTextWithPoints,
  SliceIntroText,
  SliceImages,
  SliceEmbed,
  SliceTableWithImages,
  SliceRelatedContent,
  SliceProductCards,
  SliceArticleCards,
  SliceOtherCards,
  SliceTextCards,
  SliceTableWithImages,
  HighlightNumbers,
  SlicePageVideo,
  SliceArticleHero,
  SliceFeaturedArticles,
  SliceTextWithImage,
  SliceTextWithVideo,
  SliceTextWithPullOut,
  SliceTextWithWithSideText,
  SliceTextWithRelated,
  SliceTextWithLinks,
  SliceEmphasisText,
  SliceQuote,
  SliceVideo,
  AnnualHero,
  SliceAnnualModule,
  Tiles,
  AnnualIntro,
  AnnualQuote,
  TextWithNumbers,
  Boxes,
  TableWithLargeText,
  SliceBecomeCustomer,
  SliceJotForm,
  SliceServiceLocations,
  SlicePoints,
  SliceFaq,
  SliceContentNav,
  SliceInterestCallout,
  SliceStaffWithContact,
  SliceStaffWithBio,
  SliceDetailCards,
  SliceNewsCards,
  SliceMoreInfo,
  SliceCardInfo,
  SliceCustomModule,
  SliceDownloadLinks,
  SliceIframe,
  SliceMailingList,
  SliceMarkets,
  SliceEventRegistration,
  SliceQuarters,
  SliceTable,
  SliceAccordion,
  SliceTextWithImages,
  SliceGdprRequest,
  SliceShortcuts,
  SliceFeaturedPodcasts,
  SliceOrderGiftCard,
  SliceBookAppointment,
  SliceTermsDialog,
  SliceKauphollNews,
  SliceImageLink,
  SliceInfogram,
  SliceScrollToModuleOnLoad,
];
